!((document, Drupal, $) => {
  'use strict';

  /**
   * Creates behavior for sticky header functionality.
   */
  Drupal.behaviors.stickyHeader = {
    attach: function (context) {

      if (!$('body').hasClass('toolbar-fixed')) {
        $('.site-header', context).once().sticky({
          topSpacing: 0,
          wrapperClassName: 'header-sticky-wrapper'
        });

        $(window).scroll(function () {
          if ($(window).scrollTop() > 10) {
            $('.site-header').addClass('minimal');
          }
          else {
            $('.site-header').removeClass('minimal');
          }
        });
      }

    }
  };
})(document, Drupal, jQuery);
